import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from './shared';

const JSONPayloadSize = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [input, setInput] = useState('');
  const [res, setRes] = useState<any>(null);

  const calculate = () => {
    try {
      JSON.parse(input);
      const b = new TextEncoder().encode(input).length;
      setRes({ bytes: b, kb: (b / 1024).toFixed(2), mb: (b / 1024 / 1024).toFixed(4) });
    } catch (e) {
      setRes(null);
    }
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <FormField label="JSON Payload" value={input} onChange={setInput} type="textarea" />
        <div className="flex justify-center my-6">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold">Calcular Tamanho</button>
        </div>
        {res && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <ResultCard title="Bytes" value={res.bytes} color="blue" />
            <ResultCard title="KB" value={res.kb} color="purple" />
            <ResultCard title="MB" value={res.mb} color="indigo" />
          </div>
        )}
      </div>
    </div>
  );
};

export default JSONPayloadSize;
